// extracted by mini-css-extract-plugin
module.exports = {"select":"project-selector_select__iKt7X","menuIcon":"project-selector_menuIcon__1I9Ow"};